import { useEffect, useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { ITaskOperationValue } from "../../models/Task";

// Import styles
import classes from "./TaskOperationFixedFiled.module.scss";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { updateTaskTmpAttributes } from "../../pages/TaskManagement/module/actions";
import { selectSelectedTaskTmpAttributes } from "../../pages/TaskManagement/module/selector";
import messages from "./module/messages";
import {
  formatDateForInput,
  generateTimeStamp,
  getCorrectTaskInputType,
  isDateTaskInputValue,
} from "./module/utils";

interface TaskOperationFieldProps {
  attribute?: ITaskOperationValue;
  taskId: string;
  label: string;
  tmpAttributes: any;
  updateTaskTmpAttributes: (payload: {
    taskId: string;
    newValue?: string;
    field: string;
    isBeingEdited?: boolean;
  }) => void;
  onChangeValue: (newValue: string | undefined, label: string) => void;
}

const TaskOperationFixedField = (props: TaskOperationFieldProps) => {
  const {
    attribute,
    taskId,
    label,
    tmpAttributes,
    onChangeValue,
    updateTaskTmpAttributes,
  } = props;

  const [editingEnable, setEditingEnabled] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (
      tmpAttributes &&
      tmpAttributes[taskId] &&
      tmpAttributes[taskId][label] &&
      tmpAttributes[taskId][label].isBeingEdited
    ) {
      setValue(tmpAttributes[taskId][label].newValue);
      setEditingEnabled(tmpAttributes[taskId][label].isBeingEdited);
    } else {
      setValue(attribute?.newValue as string);
    }
  }, []);

  const startEditing = () => {
    setValue("");
    setEditingEnabled(true);
    updateTaskTmpAttributes({ taskId, field: label, isBeingEdited: true });
  };

  const stopEditing = () => {
    setValue(attribute?.newValue as string);
    onChangeValue(undefined, label);
    setEditingEnabled(false);
    updateTaskTmpAttributes({ taskId, field: label, isBeingEdited: false });
  };

  const changeValueHandler = (e: any) => {
    if (!e) {
      return;
    }
    if (isDateTaskInputValue(label)) {
      const timeStamp = generateTimeStamp(e.target.value);
      onChangeValue("" + timeStamp, label);
      setValue("" + timeStamp);
    } else {
      onChangeValue(e.target.value, label);
      setValue(e.target.value);
    }
    updateTaskTmpAttributes({ taskId, field: label, newValue: e.target.value });
  };

  return (
    <div className={classes["field-wrapper"]}>
      <label htmlFor="input">{<FormattedMessage {...messages[label]} />}</label>
      <span>
        <input
          id="input"
          type={getCorrectTaskInputType(label)}
          value={
            isDateTaskInputValue(label)
              ? formatDateForInput(value) || ""
              : value || ""
          }
          onKeyDown={
            isDateTaskInputValue(label) ? (e) => e.preventDefault() : (e) => e
          }
          onChange={changeValueHandler}
          disabled={!editingEnable}
        />
        {!editingEnable && <FaEdit onClick={startEditing} />}
        {editingEnable && <FaTimes onClick={stopEditing} />}
      </span>
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    tmpAttributes: selectSelectedTaskTmpAttributes,
  });

const mapDispatchToProps: any = {
  updateTaskTmpAttributes,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(TaskOperationFixedField);
